<mat-form-field [floatLabel]="'never'" class="search mat-block" [ngClass]="{'full-block': hideClearFilterBtn}">
  <input matInput type="text" [formControl]="searchCtrl"
    [matTooltip]="inputTooltip" matTooltipPosition="above" matTooltipClass="text-center"
    [placeholder]="inputPlaceholder" class="example-right-align">

  <i class="far fa-search"></i>
  <i *ngIf="searchCtrl.value.length > 0" (click)="$event.stopPropagation();onClearSearch()" class="far fa-times"></i>
</mat-form-field>

<app-cancel-filters *ngIf="!hideClearFilterBtn" [filterGroup]="filterGroup" [filterControl]="filterControl" (clearFilters)="onClearFilters()"></app-cancel-filters>
